export const STATUS = {
	active: 'Activo',
	inactive: 'Inactivo',
	empty: 'Vacío',
};
